// extracted by mini-css-extract-plugin
export default {"btn":"pNx6f3zzwKGN9L2oELWX","play":"SexWdU2zVJ9rx5NwzKoe","pause":"dZzkDgCp2K4yXwTWpmyT"};